import { render, staticRenderFns } from "./RelationsMap.vue?vue&type=template&id=8ac66e20"
import script from "./RelationsMap.vue?vue&type=script&lang=js"
export * from "./RelationsMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports